import { InputField } from "components/ui/InputField";
import { PasswordField } from "components/ui/TextField/PasswordField";
import { TextLink } from "components/ui/TextLink";
import { FieldErrors, UseFormRegister } from "react-hook-form";
import { LoginFormValues } from "../types";

type Props = {
  errors: FieldErrors<LoginFormValues>;
  register: UseFormRegister<LoginFormValues>;
};

export const PasswordInputField = ({ errors, register }: Props) => {
  return (
    <InputField
      error={errors.password}
      rightItem={
        <div className="flex justify-end">
          <TextLink as="a" theme="primary" size="sm" href="/password_reset">
            パスワードを忘れた場合はこちら
          </TextLink>
        </div>
      }
      size="xs"
      title="パスワード"
      block
    >
      <PasswordField
        block
        error={errors.password}
        {...register("password", {
          required: true,
          setValueAs: (v) => (v as string).trim(),
        })}
        placeholder="・・・・・・・・"
      />
    </InputField>
  );
};
